import { render, staticRenderFns } from "./backlog.vue?vue&type=template&id=af4ca6c0"
import script from "./backlog.vue?vue&type=script&lang=js"
export * from "./backlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports